import * as React from 'react';

const AccountIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7646 16.5C15.2499 16.5 17.2646 14.4853 17.2646 12C17.2646 9.51472 15.2499 7.5 12.7646 7.5C10.2794 7.5 8.26465 9.51472 8.26465 12C8.26465 14.4853 10.2794 16.5 12.7646 16.5Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.2715 7.561C19.4934 7.8867 19.6904 8.2286 19.861 8.58381L22.2935 9.93414C22.5897 11.2949 22.5908 12.7034 22.2964 14.0645L19.8626 15.4156C19.6915 15.7706 19.4939 16.1121 19.2716 16.4375L19.3184 19.2192C18.2881 20.1562 17.0688 20.8613 15.7428 21.287L13.3559 19.8548C12.9629 19.8841 12.5683 19.8837 12.1754 19.8539L9.78973 21.2853C8.46314 20.8615 7.24287 20.1581 6.2112 19.2227L6.25805 16.4394C6.03623 16.1137 5.83919 15.7718 5.66861 15.4166L3.23615 14.0663C2.93987 12.7055 2.93885 11.297 3.23317 9.93585L5.66698 8.58478C5.83813 8.22983 6.0357 7.88824 6.25804 7.5629L6.21122 4.78117C7.24153 3.8442 8.46079 3.13909 9.78676 2.71338L12.1737 4.14559C12.5667 4.11633 12.9613 4.11665 13.3542 4.14652L15.7399 2.7151C17.0665 3.1389 18.2867 3.84225 19.3184 4.77772L19.2715 7.561Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default AccountIcon;
